(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["global-3column-cta"]) return;
  try {
    

    $(document).ready(function() {
        var settings = {
            arrows: false,
            draggable: true,
            infinite: true,
            dots: true,
            adaptiveHeight: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            responsive: [{
                breakpoint: 1024,
                settings: "unslick"
            },
            {
             breakpoint: 600,
             settings: {
                slidesToShow: 2,
             }
            }]
        }

        var $slides = $('.wayfx-block--global-3column-cta .grid');

        $(window).on('load resize orientationchange', function () {
            if ($(window).width() > 1023) {
                if ($slides.hasClass('slick-initialized')) {
                    $slides.slick('unslick');
                }
                $slides.show();
                return
            }
            if (!$slides.hasClass('slick-initialized')) {
                return $slides.slick(settings).show();
            }
        });

    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mos2--product-showcase-card"] && !window.DesignMode) return;
  try {
    

 $(document).ready(function() {
      $('.showcase-product-grid').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            draggable: true,
            infinite: false,
            dots: false,
            variableWidth: true,
            touchThreshold: 100,
      }).show();
 });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mos2--product-showcase-mini-card"] && !window.DesignMode) return;
  try {
    

 $(document).ready(function() {
      $('.showcase-product-grid').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            draggable: true,
            infinite: false,
            dots: false,
            variableWidth: true,
            touchThreshold: 100,
      }).show();
 });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["MOS2-Media"] && !window.DesignMode) return;
  try {
    

 $(document).ready(function() {
      $('.wayfx-block--media-grid .wayfx-block__slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            draggable: true,
            infinite: true,
            dots: true,
            adaptiveHeight: false,
            mobileFirst: true,
            responsive: [{
                breakpoint: 768,
                settings: {
                    adaptiveHeight: false,
                    arrows: true,
                    draggable: false
                }
            }]
      }).show();

      var settings = {
        arrows: false,
        draggable: true,
        infinite: false,
        dots: false,
        adaptiveHeight: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: false,
        responsive: [{
            breakpoint: 1024,
            settings: {
                settings: "unslick"
            }
        }]
    }

    var $slides = $('.wayfx-block--media-grid .wayfx-row__one');

    $(window).on('load resize orientationchange', function () {
        if ($(window).width() > 1023) {
            if ($slides.hasClass('slick-initialized')) {
                $slides.slick('unslick');
            }
            $slides.show();
            return
        }
        if (!$slides.hasClass('slick-initialized')) {
            return $slides.each(function() {
                $(this).slick(settings).show();
            });
        }
    });

 });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["n-before-after-slider"] && !window.DesignMode) return;
  try {
    

 $(document).ready(function() {
      $('.wayfx-block--before-after__slider-active').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            draggable: false,
            infinite: true,
            swipe: false,
            dots: false
      }).show();
 });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["n-product-experts"] && !window.DesignMode) return;
  try {
    

 $(document).ready(function() {
      $('.wayfx-product__experts-list.wayfx-product__experts-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            draggable: false,
            infinite: true,
            dots: true
      }).show();
 });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["n-quotes"] && !window.DesignMode) return;
  try {
    
   $(document).ready(function() {
        $('.wayfx-block--home-what-experts-say .wayfx-block__slider').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              draggable: true,
              infinite: true,
              dots: true,
              adaptiveHeight: false,
              mobileFirst: true,
              responsive: [{
                  breakpoint: 768,
                  settings: {
                      adaptiveHeight: false,
                      arrows: true,
                      draggable: false,
                      dots: false,
                      slidesToShow: 2,
                      slidesToScroll: 1
                  }
              }]
        }).show();
   });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["n-slideshow"] && !window.DesignMode) return;
  try {
    

var heroSliderSettings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  speed: 300,
  draggable: true,
  infinite: true,
  adaptiveHeight: false,
  useTransform: false,
  mobileFirst: true,
  dots: true,
  autoplay: true,
  autoplaySpeed: 5000,
  responsive: [{
    breakpoint: 768,
    settings: {
      draggable: false
    }
  }]
};

var $slides = $('.wayfx-block--hero-slider');

document.addEventListener("shopify:section:unload", function(event) {
  $slides.slick('unslick');
});

document.addEventListener("shopify:section:load", function(event) {
  $slides.slick(heroSliderSettings);
});

$slides.slick(heroSliderSettings);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2_recommended-products"] && !window.DesignMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations-v2');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          initVariantSelectors();
          initEmbla();
          window.yotpoWidgetsContainer?.initWidgets();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  function initEmbla() {
    const emblaNodes = document.querySelectorAll('.js-embla');

    emblaNodes.forEach(async (node) => {
      const container = node.querySelector('.embla__container');
      const slides = container.querySelectorAll('.embla__slide');

      // If we have fewer than 4 slides, try to get more products from backup URL
      if (slides.length < 4) {
        const productRecommendationsSection = document.querySelector('.product-recommendations-v2');
        const backupUrl = productRecommendationsSection?.dataset.backup;

        if (backupUrl) {
          try {
            const response = await fetch(backupUrl);
            const text = await response.text();
            const html = document.createElement('div');
            html.innerHTML = text;
            const backupRecommendations = html.querySelector('.product-recommendations-v2');

            if (backupRecommendations && slides.length < 4) {
              const backupSlides = backupRecommendations.querySelectorAll('.embla__slide');
              const neededSlides = 4 - slides.length;

              // Add backup slides to reach 4 total
              backupSlides.slice(0, Math.min(neededSlides, backupSlides.length)).forEach((backupSlide) => {
                const clone = backupSlide.cloneNode(true);
                container.appendChild(clone);
              });
            }
          } catch (error) {
            console.error('Failed to fetch backup products:', error);
            // Fallback to cloning if backup fetch fails
            fallbackToCloning(container, slides);
          }
        } else {
          // No backup URL available, fallback to cloning
          fallbackToCloning(container, slides);
        }
      }

      // Re-query slides after potential additions
      const updatedSlides = container.querySelectorAll('.embla__slide');

      const options = {
        align: 'start',
        slidesToScroll: 'auto',
        loop: updatedSlides.length < 4, // Enable loop if we have fewer than 4 items
      };

      const embla = new window.EmblaCarousel(node, options);
    });
  }

  function fallbackToCloning(container, slides) {
    if (slides.length < 4) {
      const neededClones = 4 - slides.length;
      const originalSlides = Array.from(slides);

      // Clone items to reach 4 total
      Array.from({ length: neededClones }).forEach((_, i) => {
        const clone = originalSlides[i % originalSlides.length].cloneNode(true);
        // Update variant IDs and other unique identifiers to avoid duplicates
        const newVariantId = clone.querySelector('.js-variant-selector').value;
        clone.querySelector('.js-atc-button').setAttribute('data-variant-id', newVariantId);
        container.appendChild(clone);
      });
    }
  }

  function initVariantSelectors() {
    document.querySelectorAll('.js-variant-selector').forEach((select) => {
      const handleVariantChange = function () {
        const productCard = this.closest('.product-card');
        const button = productCard.querySelector('.js-atc-button');
        const selectedOption = this.options[this.selectedIndex];
        const variantId = selectedOption.value;

        // Update variant ID on button
        button.setAttribute('data-variant-id', variantId);

        // Get the price span container
        const priceSpan = button.querySelector('.js-recommended-price');
        if (!priceSpan) return;

        // Update the price HTML with the new variant's price structure
        priceSpan.innerHTML = selectedOption.dataset.price;

        // Initialize sitewide pricing if available
        if (window.sitewide) {
          window.sitewide.updatePriceV2(variantId, document, true);
        }
      };

      // Add change event listener
      select.addEventListener('change', handleVariantChange);

      // Trigger the handler for the initially selected option
      handleVariantChange.call(select);
    });
  }

  const productRecommendationsSection = document.querySelector('.product-recommendations-v2');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  // Initialize variant selectors and embla for products that are already loaded
  initVariantSelectors();
  initEmbla();

  } catch(e) { console.error(e); }
})();
})();
